<template>
  <div class="animated revealUp">
    <div class="white-wrapper">
      <div class="section-title">{{ $t("entryPointActivityReport") }}</div>
      <div class="mt-3 mb-4 border-bottom">
        <div class="row">
          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="dropdown-curve-container">
              <label :class="selectedCinema ? 'shift-up' : ''">{{
                $tc("cinema", 1)
              }}</label>
              <multiselect
                v-model="selectedCinema"
                :allowEmpty="false"
                :options="Cinemas"
                :searchable="true"
                :showLabels="false"
                label="cine_name"
                placeholder="Select Cinema"
                track-by="cine_id"
              ></multiselect>
            </div>
          </div>
          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <!-- <button class="btn-clearDate" v-if="fromDate">
                    ✖
                  </button> -->
                <Datepicker
                  :monday-first="true"
                  type="date"
                  ref="programaticOpen"
                  v-model="fromDate"
                  v-validate="'required'"
                  @selected="onChangedate($event, 'from')"
                ></Datepicker>
                <label :class="fromDate ? 'active' : ''">
                  <!-- {{ $t("show") }} -->
                  {{ $t("fromdate") }}
                </label>
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <!-- <button class="btn-clearDate" v-if="toDate">
                    ✖
                  </button> -->
                <Datepicker
                  :monday-first="true"
                  ref="programaticOpen"
                  v-model="toDate"
                  v-validate="'required'"
                >
                </Datepicker>
                <label :class="toDate ? 'active' : ''">
                  <!-- {{ $t("show") }}  -->
                  {{ $t("todate") }}</label
                >
              </div>
            </div>
          </div>

             <!-- show time filter -->
                                         <div class="position-relative col-lg-3 col-xl-2 mb-2">
                                           <vue-timepicker manual-input
                                            v-model="start_time"
                                             id="starttime"
                                             name="starttime"
                                             :placeholder="$tc('starttime')"
                                             format="HH:mm" 
                                             class="time_picker" 
                                             input-width="100%" auto-scroll
                                             lazy ></vue-timepicker>
                                         </div>
                            
                       
                                 <div class="position-relative col-lg-3 col-xl-2 mb-2">
                         <vue-timepicker
                           manual-input
                           v-model="end_time"
                           id="endtime"
                           name="endtime"
                           :placeholder="$tc('endtime')"
                           format="HH:mm"
                           class="time_picker"
                           input-width="100%"
                           auto-scroll
                           lazy
                         />
                       </div>
                      <!-- show time filter -->

                                    <!-- Screen Filter -->
                                                    <div class="col-12 col-md-6 col-lg-2 col-xl-2 align-self-center mb-3">
                                          <div class="dropdown-curve-container">
                                             <label :class="selectedScreen && selectedScreen.length > 0 ? 'shift-up' : 'font-weight-bold'">
                                            {{ selectedScreen && selectedScreen.length > 0 ? $t("Screens") : $t("All Screens") }}
                                            </label>
                                            <multiselect
                                              :options="screenList"
                                              v-model="selectedScreen"
                                              placeholder=""
                                              label="screen_name"
                                              :multiple="true"
                                              :close-on-select="false"
                                              track-by="screen_id"
                                            ></multiselect>
                                          </div>
                                        </div>
                                                     <!-- Screen Filter -->

          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <button class="btn-blue-lg w-100" @click="getShowLists('N','N')">
              {{ $t("fetch") }}
            </button>
          </div>
          <div class="col-md-3 align-self-center"></div>
        </div>
      </div>

      <div class="swc-report text-right" v-if="scheduleShows.length">
        <span>Download as: </span>&nbsp;
        <span @click="getShowLists('Y','N')" title="Download as Excel" style="cursor: pointer;">
          <img src="@/assets/img/icons/excel.svg" height="25" width="25" />
        </span>

        <span @click="getShowLists('N','Y')" title="Download as Pdf" style="cursor: pointer;">
          <img src="@/assets/img/icons/pdf-icon.svg" height="25" width="25" />
        </span>
      </div>

      <div class="swc-report" style="margin-top: 20px">
        <div>
          <table
          
         class="swc-report-table mb-3" border="1"
            
          >
            <thead
              style="
                font-size: 14px;
                text-align: center;
                background-color: #c4c5c6;
              "
            >
              <tr>
                <th>Date</th>
                <th>Show Time</th>
                <th>Screen</th>
                <th>Total Reservations</th>
                <th>Onsite</th>
                <th>Online</th>
                <th>check-in OnSite</th>
                <th>check-in online</th>
                <th>Check-in location BO</th>
                <th>Check-in Location Control</th>
              </tr>
            </thead>
            <tbody style="font-size: 14px" v-if="scheduleShows.length">
              <tr
                v-for="(showObj, showIndex) in scheduleShows"
                :key="showIndex"
              >
                <td class="text-left" style="width: 110px;">{{ showObj.show_date }}</td>
                <td class="text-left">{{ showObj.show_time }}</td>
                <td class="text-left" style="width: 100px;">{{ showObj.screen_name }}</td>
                <td class="text-right">{{ showObj.total_bookings }}</td>
                <td class="text-right">{{ showObj.pos_bookings }}</td>
                <td class="text-right">{{ showObj.online_bookings }}</td>
                <td class="text-right">{{ showObj.pos_check_in }}</td>
                <td class="text-right">{{ showObj.online_check_in }}</td>
                <td class="text-right">{{ showObj.checkIn_bo }}</td>
                <td class="text-right">{{ showObj.checkIn_usher }}</td>
              </tr>
              <tr>
                <td class="text-left font-weight-bold bg-lightgrey" colspan="3">
                  Total
                </td>
                <td class="text-right font-weight-bold bg-lightgrey">
                  {{
                    scheduleShows.reduce(
                      (acc, { total_bookings }) => acc + total_bookings,
                      0
                    )
                  }}
                </td>
                <td class="text-right font-weight-bold bg-lightgrey">
                  {{
                    scheduleShows.reduce(
                      (acc, { pos_bookings }) => acc + pos_bookings,
                      0
                    )
                  }}
                </td>
                <td class="text-right font-weight-bold bg-lightgrey">
                  {{
                    scheduleShows.reduce(
                      (acc, { online_bookings }) => acc + online_bookings,
                      0
                    )
                  }}
                </td>
                <td class="text-right font-weight-bold bg-lightgrey">
                  {{
                    scheduleShows.reduce(
                      (acc, { pos_check_in }) => acc + pos_check_in,
                      0
                    )
                  }}
                </td>
                <td class="text-right font-weight-bold bg-lightgrey">
                  {{
                    scheduleShows.reduce(
                      (acc, { online_check_in }) => acc + online_check_in,
                      0
                    )
                  }}
                </td>
                <td class="text-right font-weight-bold bg-lightgrey">
                  {{
                    scheduleShows.reduce(
                      (acc, { checkIn_bo }) => acc + checkIn_bo,
                      0
                    )
                  }}
                </td>
                <td class="text-right font-weight-bold bg-lightgrey">
                  {{
                    scheduleShows.reduce(
                      (acc, { checkIn_usher }) => acc + checkIn_usher,
                      0
                    )
                  }}
                </td>
              </tr>
            </tbody>
            <tbody style="font-size: 14px" v-else>
              <tr>
                <td colspan="10">
                  <NoRecords />
                </td>
              </tr>
         </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
  
  <script>
import { BASEURL } from "@/config/index";
import MasterService from "@/services/MasterService";
import ReportService from "@/services/ReportsService";
import vue from "vue";
import moment from "moment";
import NoRecords from "@/components/Partials/NoRecords.vue";
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";

export default {
  components: {
    NoRecords,
    VueTimepicker
  },
  data() {
    return {
      screenList: [],
      selectedScreen: [],
      end_time: "",
      start_time: "",
      BASEURL,
      PdfPath: "",
      ExcelPath: "",
      Cinemas: [],
      isRoleID: true,
      selectedCinema: null,
      scheduleShows: [],
      fromDate: new Date(),
      toDate: new Date(),
    };
  },
  computed: {},
  watch: {
    selectedCinema(newVal) {
    if (newVal && newVal.cine_id) {
      this.getCinemaScreens();
    }
  },
  },
  beforeMount() {
    let roleid = this.secureStore.get("USINFO").role_id;
    let cinemaId =
      this.secureStore.get("USINFO") &&
      this.secureStore.get("USINFO")["cinema_id"]
        ? this.secureStore.get("USINFO").cinema_id
        : null;
    this.cinema_id = cinemaId;
    this.getCinemaList(cinemaId);
  },
  mounted() {
    let CinemaObj = this.$store.getters.getSelectedDropDownCinema;
    if (CinemaObj) {
      this.selectedCinema = CinemaObj;
    }
  },
  created() {},
  methods: {
    onChangedate(e, type) {
      if (type == "from") {
        this.toDate = new Date(e);
        this.$forceUpdate();
      }
    },
    moment,
    // getCinemaList: function (cine_id) {
    //   this.Cinemas = [];
    //   MasterService.GetCinemasByRoles({ cine_id: cine_id })
    //     .then((response) => {
    //       const { data } = response;
    //       if (data.status && data.Records.length > 0) {
    //         this.Cinemas = data.Records;
    //       } else {
    //         this.$toasted.show(data.message);
    //       }
    //     })
    //     .catch(this._CatchError);
    // },
    getCinemaList: function (cine_id) {
      this.Cinemas = [];
      MasterService.GetCinemasByRoles({ cine_id: cine_id })
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.Cinemas = data.Records;

            let CinemaObj = this.$store.getters.getSelectedDropDownCinema;
            if (CinemaObj && CinemaObj.cine_id) {
              const matchedCinema = this.Cinemas.find(
                (cinema) => cinema.cine_id === CinemaObj.cine_id
              );
              if (matchedCinema) {
                this.selectedCinema = matchedCinema;
              } else {
                this.selectedCinema = this.Cinemas[0];
              }
            } else {
              this.selectedCinema = this.Cinemas[0];
            }
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
      async getCinemaScreens(index) {
          try {
            const response = await MasterService.GetActiveList({
              tableName: "screens",
              screen_is_active: "Y",
              cinema_id: this.selectedCinema.cine_id,
            });
            const { data } = response;
            if (data.status && data.Records.length > 0) {
              this.screenList = data.Records;
            } else {
              console.log("show error:", data.message);
            }
          } catch (error) {
            this._CatchError(error);
          }
        },
    getShowLists(isExcel = "N", isPdf = "N") {
   
      if (!this.selectedCinema.cine_id) {
        this.$toasted.show("Please select a cinema");
        return;
      }

      if (!this.fromDate || !this.toDate) {
        return this.$toasted.show("Please select Valid Dates");
      }

      this.scheduleShows = [];
      let loader = vue.$loading.show();
      let payload = {
        cinema_id: this.selectedCinema.cine_id,
        cinema_name: this.selectedCinema.cine_name,
        cinema_address: this.selectedCinema.cine_address,
        fromDate: moment(this.fromDate).isValid()
          ? moment(this.fromDate).format("YYYY-MM-DD")
          : moment().format("YYYY-MM-DD"),
        toDate: moment(this.toDate).isValid()
          ? moment(this.toDate).format("YYYY-MM-DD")
          : moment().format("YYYY-MM-DD"),
          start_time:this.start_time,
          end_time:this.end_time,
          screen_name: this.selectedScreen.map(x => x.screen_name),
          screen_id: this.selectedScreen.map(x => x.screen_id),
            isPdf,
              isExcel
      };



      ReportService.GetEntryPointActivityReport(payload)
        .then((response) => {
        
          const { data } = response;
          if (data && data.status && data.Records.length) {
            this.scheduleShows = [...data.Records];
            if (data.excelPath && isExcel == "Y") {
              window.open(data.excelPath, "_blank");
            }
             if (data.PdfPath && isPdf == "Y") {
              window.open(data.PdfPath, "_blank");
            }
          } else {
            this.$toasted.show(data["message"] || "No Records Found!");
          }
        })
        .catch((err) => {
          console.log("Error:", err);
        })
        .finally(() => {
          loader.hide();
        });
    },
  },
};
</script>
  
  <style>
.border-bottom-black {
  border-bottom: 1px solid #787878 !important;
}

.mobile-occupancy-report table {
  width: 100%;
}

.mobile-occupancy-report * {
  border-color: #eaeaed;
}

.mobile-occupancy-report .mobile-occupancy-sub-report {
  margin: 0 -15px 20px;
}

.mobile-occupancy-report .mobile-occupancy-sub-report td {
  padding: 10px;
}

.mobile-occupancy-report .mobile-occupancy-sub-report tr > td:first-child {
  font-weight: bold;
  background-color: #f5f5f7;
}

.mobile-occupancy-report .mobile-occupancy-sub-report .sub-report-toggle {
  padding: 10px 15px;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.mobile-occupancy-report
  .mobile-occupancy-sub-report
  .sub-report-toggle
  span:not(:last-child)::after {
  content: "|";
  padding: 0 4px;
}

.td {
  padding: 6px;
}
.table_td td {
  padding: 6px;
}

.bg-transparent-blue td {
  padding: 6px;
}

.table tr td.td {
  width: 163px !important;
  white-space: normal !important;
  font-weight: bold;
}

/* .table-wrapper {
  max-height: 600px;
  overflow-y: auto;
} */

/* .table-wrapper thead th {
  position: sticky;
  top: 0;
  z-index: 1;
  background-color: #c4c5c6;
} */

/* .table-wrapper th,
.table-wrapper td {
  text-align: center;
  padding: 8px;
} */

.table-wrapper {
  position: relative;
  overflow: auto;
  max-height: 400px;
}

.main-header {
  position: sticky;
  top: 0;
  z-index: 2;
}

/* .table-wrapper table {
  border: 1px solid black !important;
} */

/* .table-wrapper th, .table-wrapper td {
  border: 1px solid black !important;
}

 th {
  border: 1px solid black !important;
} */

/* .date-header {
  position: sticky !important;
  top: 30px !important;
  z-index: 1 !important;
} */
</style>
  


// WEBPACK FOOTER //
// src/components/Pages/ReportsContainer/EntryPointActivityReport.vue